import React from 'react';
import { formatCurrencyINR } from '../../utils/format';

function Delta({ value }) {
  if (value == null || !Number.isFinite(value)) return <span className="text-slate-400">—</span>;
  const up = value >= 0;
  return (
    <span className={up ? 'text-emerald-600' : 'text-red-600'}>
      {up ? '+' : ''}
      {Math.round(value)}% vs prior 30d
    </span>
  );
}

function Card({ label, value, sub, loading, isDarkMode }) {
  return (
    <div
      className={`rounded-xl border px-4 py-3 min-w-[9rem] flex-1 ${
        isDarkMode ? 'border-slate-700 bg-slate-800/50' : 'border-slate-200 bg-white'
      }`}
    >
      <p className={`text-[10px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
        {label}
      </p>
      <p className={`mt-1 text-xl font-bold tabular-nums ${isDarkMode ? 'text-white' : 'text-slate-900'}`}>
        {loading ? '…' : value}
      </p>
      {sub != null && (
        <p className={`mt-1 text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-500'}`}>{sub}</p>
      )}
    </div>
  );
}

export default function StoreHubPortfolioSummary({ portfolio, loading, isDarkMode }) {
  const counts = portfolio?.storeCounts;
  const totals = portfolio?.totals;
  if (!counts && !loading) return null;

  const totalStores = counts?.total ?? 0;
  const activeStores = counts?.activeInPeriod ?? counts?.connected ?? 0;
  const activePct = totalStores > 0 ? Math.round((activeStores / totalStores) * 100) : 0;
  const spend = totals?.current?.spend;
  const sales = totals?.current?.sales;

  return (
    <div className="mb-5">
    <div className="flex gap-3 overflow-x-auto pb-1 scrollbar-thin">
      <Card
        label="Total stores"
        value={totalStores}
        sub={counts?.connected != null ? `${counts.connected} connected` : undefined}
        loading={loading}
        isDarkMode={isDarkMode}
      />
      <Card
        label="Active stores"
        value={activeStores}
        sub={totalStores > 0 ? `${activePct}% with ad activity` : undefined}
        loading={loading}
        isDarkMode={isDarkMode}
      />
      <Card
        label="Total ad spend"
        value={spend != null ? formatCurrencyINR(spend) : '—'}
        sub={<Delta value={totals?.deltaPct?.spend} />}
        loading={loading}
        isDarkMode={isDarkMode}
      />
      <Card
        label="Total sales"
        value={sales != null ? formatCurrencyINR(sales) : '—'}
        sub={<Delta value={totals?.deltaPct?.sales} />}
        loading={loading}
        isDarkMode={isDarkMode}
      />
      <Card
        label="Ad sales"
        value={sales != null ? formatCurrencyINR(sales) : '—'}
        sub={<Delta value={totals?.deltaPct?.sales} />}
        loading={loading}
        isDarkMode={isDarkMode}
      />
    </div>
    <p className={`mt-2 text-[10px] leading-relaxed ${isDarkMode ? 'text-slate-500' : 'text-slate-500'}`}>
      Tags: <strong>Active</strong> on all stores with spend/sales · vs prior 30d —
      Top performer ≥+10% sales · Growing ≥+5% · Trending ≥+3% spend ·
      Underperforming ≤−5% sales · High priority ≤−10% sales · Moderately performing −2% to +2% sales
    </p>
    </div>
  );
}
